import React from "react";
import { Box } from "@mui/material";

export default function Loading() {
  return (
    <Box
      sx={{
        alignItems: "center",
        textAlign: "center",
        marginTop: "20%",
        userSelect: "none",
      }}
    >
      <img src="./img/loading.webp" style={{ width: "100px" }} />
    </Box>
  );
}
